import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse} from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';
@Injectable()
export class DealsDetailsProviderService {

    // setyp_api = tabsProviderService.BASE_URL_DEV+"setyp/v1"
    url = 'https://api.dev-dnr.acg.aaa.com/dedet/v1';


    constructor(private http: HTTP, private config: ConfigurationManager) { }


     getDealDetailsData(data) {
        this.config.setEnvironmentConfig = (data.EnvironmentName) ? data.EnvironmentName : 'STG';
        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };
        // data.Latitude,data.Longitude,data.DealID,data.ScreenTitle
        const params = {
            'Latitude': '' + data.Latitude,
            'Longitude': '' + data.Longitude,
            'ScreenTitle': 'All Deals',
            'SessionID': this.config.getSessionId,
            'ProxyUI': data.ProxyUI,
            'ClubID': data.ClubCode,
            'FromNewDNR': 'true',
            'DealID': '' + data.DealID,
            'fromEmail': 'false'
        };
        console.log('environment is ' + this.config.getEnvironmentName);
        console.log('request::::params' + JSON.stringify(params));
        console.log('request::::headers' + JSON.stringify(headers));
        const url = this.config.environmentConfig.baseurl + 'dedet/v1';
        return this.http.get(url, params, headers);

    }

}
